/** The three groups the Documents column counts. */
export type DocBucket = "approved" | "completed" | "missing";

export type DocStatus = {
  label: string;
  colorScheme: string;
  bucket: DocBucket;
};

type DocStatusInput = {
  approved: boolean;
  submitted: boolean;
  isOpenForResubmission: boolean;
  reopenHistory: { nodes: unknown[] };
};

// Order of checks encodes precedence: approved > open > with-fixes > submitted > missing.
// A document reopened for submission counts as missing: it is waiting on the caregiver again.
export function deriveDocStatus(doc: DocStatusInput): DocStatus {
  const wasReopened = doc.reopenHistory.nodes.length > 0;

  if (doc.approved) {
    return { label: "Approved", colorScheme: "blue", bucket: "approved" };
  }
  if (doc.isOpenForResubmission) {
    return { label: "Reopened for submission", colorScheme: "orange", bucket: "missing" };
  }
  if (doc.submitted && wasReopened) {
    return { label: "Completed with fixes", colorScheme: "teal", bucket: "completed" };
  }
  if (doc.submitted) {
    return { label: "Completed", colorScheme: "green", bucket: "completed" };
  }
  return { label: "Missing", colorScheme: "red", bucket: "missing" };
}

export function countDocsByBucket(docs: DocStatusInput[]): Record<DocBucket, number> {
  const counts: Record<DocBucket, number> = { approved: 0, completed: 0, missing: 0 };
  for (const doc of docs) {
    counts[deriveDocStatus(doc).bucket]++;
  }
  return counts;
}
